{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
{{#if options}}
  {{#equal display_style 'radio'}}
    {{#each options}}
      <dd class="radio-wrapper">
        <input type="radio" name="{{../prefix}}[trait][{{../trait_id}}]" id="trait_{{../trait_id}}_{{this}}" {{#if ../value}}{{#equal this ../value}}checked{{/equal}}{{else}}{{#unless @index}}checked{{/unless}}{{/if}} value="{{this}}" />
        <label for="trait_{{../trait_id}}_{{this}}">{{@key}}</label>
      </dd>
    {{/each}}
  {{else}}
    <dd>
      {{sp_select_tag (sp_select_name prefix "[trait][" trait_id "]")
        choices=select_items
        includeBlank=false
        searchable=select_searchable
        selected=value
        id=id
        required=required
        disabled=disabled
      }}
    </dd>
  {{/equal}}
{{else}}
  <dd>
    <input
      {{#if value}}value="{{value}}"{{/if}}
      name="{{prefix}}[trait][{{trait_id}}]"
      id="{{id}}"
      type="text"
      {{#if required}}required{{/if}}
      {{#if disabled}}disabled{{/if}}
    />
  </dd>
{{/if}}
